import type { SavedSearch } from '../../types/saved-items';
import type { SaveService } from './save';

import { GetDefaultSavedSearchTitle } from './get-default-saved-search-title';
import { GetSavedItems } from './get-saved-items';
import { SaveRequest } from './request';

export async function SaveSearch(this: SaveService, name: string): Promise<void> {
  const _searchName = name.trim();
  if (!_searchName) {
    return;
  }

  let timeout;

  if (!this.stateService.userToken()) {
    this.stateService.handleAuthRequest();

    timeout = setTimeout(() => {
      this.stateService.authPromiseRejecter?.();

      return;
    }, 30000);
    // Wait an additional second to ensure the token is set.
    await this.stateService.authPromise();
  }

  if (!this.stateService.userToken() || !this.filteringService.hasFilters()) {
    return;
  }

  const _itemId = _searchName.toLocaleLowerCase().replaceAll(' ', '-');
  const _label = _searchName;

  const _urlParams = new URLSearchParams(window.location.search);
  _urlParams.delete('noAuth');
  const _searchString = _urlParams.toString().replaceAll('%2C', ',').replaceAll('+', ' ');

  void SaveRequest.call(this, {
    created: new Date().toISOString(),
    itemId: _itemId,
    label: _label,
    searchString: _searchString,
    type: 'listing-search',
  }).then(async (saveResponse) => {
    const _saveResult = (await saveResponse.json()) as SavedSearch | undefined;
    const _savedItemId = String(
      Array.isArray(_saveResult) ? _saveResult[0] : (_saveResult?.id ?? _itemId),
    );

    const _fields = ['created', 'id', 'itemId', 'label', 'searchString'];

    void GetSavedItems.call(this, 'listing-search', _fields).then((savedSearches) => {
      this.filteringService.userSavedSearches.set(
        (savedSearches as SavedSearch[]).map((item) => ({
          id: item.itemId === _itemId ? _savedItemId : item.id,
          label: item.label,
          searchString: item.searchString,
        })),
      );
    });

    setTimeout(() => {
      void GetDefaultSavedSearchTitle.call(this).then((lastSavedSearch) => {
        this.filteringService.userDefaultSavedSearchTitle.set(
          `Homes in the Villages${lastSavedSearch ? ` ${lastSavedSearch + 1}` : ''}`,
        );
      });
    }, 300);
  });

  clearTimeout(timeout);

  this.stateService.notifyParentOfStateChange('HF_EVENT:SEARCH_SAVED', { itemId: _itemId });
}
